// Configuration file for feature flags and environment variables
// In a real production app, these would come from environment variables
// For now, we'll set them as constants that can be easily changed

export const config = {
  // Feature Flags
  SHOP_ENABLED: false, // Set to true to enable the shop functionality

  // API Base URLs - consolidated into single environment variable
  // http://localhost:8080
  // https://api.peo-portal.com
  // https://test-api.peo-portal.com
  API_BASE_URL: 'https://api.peo-portal.com',

  // Other configuration options can be added here
  DEBUG_MODE: process.env.NODE_ENV === 'development',
};

// Helper function to check if a feature is enabled
export const isFeatureEnabled = (featureName) => {
  return config[featureName] === true;
};
